import React, { useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Select, { components } from 'react-select';
import { authActionCreators } from '../../../stores/lis-auth-store';
import { reportActionCreators } from "../../../stores/lis-report-store";
import { navActionCreators } from '../../../stores/lis-nav-store';
import LisClearIndicator from '../../../lis-shared/lis-layout/components/lis-clear-indicator';

const BILL_COLLECTION_AUTHOR = "LegislationCollections";

const selectStyle = {
    control: styles => ({
        ...styles,
        minHeight: '0px',
        padding: '0 0.6em !important',
        height: '30px',
        borderColor: "#949494"
    }),
    valueContainer: styles => ({
        ...styles,
        padding: 0,
        height: '30px'
    }),
    input: styles => ({
        ...styles,
        fontSize: '0.8em',
        lineHeight: 'normal',
        height: '30px'
    }),
    inputIndicators: styles => ({
        ...styles,
        height: '30px'
    }),
    singleValue: styles => ({
        ...styles,
        fontSize: '0.8em',
        height: '30px'
    }),
    placeholder: styles => ({
        ...styles,
        fontSize: '0.8em'
    }),
    option: styles => ({
        ...styles,
        fontSize: '0.8em'
    }),
    dropdownIndicator: styles => ({
        ...styles,
        padding: '1px',
        color: "#666666"
    }),
    clearIndicator: (base) => ({
        ...base,
        color: "#666666"
    }),
}

class ReportMaker extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            creating: false,
            showCatchline: false,
            showCurrentStatus: false,
            showTitle: false,
            showChiefPatron: false,
            showAllPatrons: false,
            showSummary: false,
            showNotes: false,
            selectedNotes: props.selectedCollection && this.props.selectedCollection.Name && this.props.selectedCollection.WatchListID ? 'current' : 'all',
            showHistory: false,
            showHouseAmendments: false,
            showSenateAmendments: false,
            showConferenceAmendments: false,
            showGovernorsRecommendations: false,
            personalMessage: '',
            showStatus: {},
            showCommitteeEvent: {},
            showAllBills: false,
            showClerkNames: false,
            showDlsStaffNames: false,
            showLdNumber: false,
            startRange: '',
            endRange: '',
            rangeError: false,
            DLS_STAFF: this.props.login && this.props.login.userClaims && this.props.login.userClaims.claims && this.props.login.userClaims.claims.find(c => c.RoleName === 'BDSDrafter'),
            reportTemplate: null,
            isDirty: false,
            shareNotes: false,
            newNote: {
                Name: '',
                ReportParameterID: -1,
                isNew: true,
                value: '',
                Description: ''
            },
            menuIsOpen: false,
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.getReportUrl = this.goToReport.bind(this);
        this.toggleShowBills = this.toggleShowBills.bind(this);
        this.checkParams = this.checkParams.bind(this);
        this.generateBillList = this.generateBillList.bind(this);
        this.selectAll = this.selectAll.bind(this);
        this.handleReportTemplateChange = this.handleReportTemplateChange.bind(this);
        this.getReportTemplates = this.getReportTemplates.bind(this);
        this.saveReportTemplate = this.saveReportTemplate.bind(this);
        this.deleteReportTemplate = this.deleteReportTemplate.bind(this);
        this.toggleMenuIsOpen = this.toggleMenuIsOpen.bind(this);
        this.handleIsRelated = this.handleIsRelated.bind(this);
        this.manuallyFocusTheNextOne = this.manuallyFocusTheNextOne.bind(this);
        this.resetForm = this.resetForm.bind(this);
        this.selectRef = React.createRef();
    }

    handleInputChange(key, val) {
        if (key === 'showHistory' && val && !val.all && (!val.recent || val.mostRecentAmount === '' || val.mostRecentAmount < 2)) {
            val.showVotes = false;
        }
        if (['startRange', 'endRange'].includes(key)) {
            val = val.replace(/[^a-zA-Z0-9]/, "");
        }
        if (key === "showNotes" && val === false) {
            this.setState({
                shareNotes: false
            })
        }
        if (key === "showHistory" && val.all === true) {
            let showHistory = { ...val }
            showHistory.mostRecentAmount = 0;
            this.setState({
                showHistory,
                rangeError: false,
                isDirty: true
            })
            return;
        }
        this.setState({
            [key]: val,
            rangeError: false,
            isDirty: true
        });
    }

    goToReport() {
        const billList = this.generateBillList();
        if (billList && billList.length === 0) {
            this.setState({
                rangeError: true
            });
        } else {
            let notes = [];

            if (this.state.shareNotes) {
                this.props.billList.forEach(bill => {
                    if (this.state.shareNotes) {
                        if (this.state.selectedNotes === 'all') {
                            this.props.collections.forEach(coll => {
                                let note = coll.WatchListLegislation.find(leg => leg.LegislationID === bill.LegislationID && leg.Note);
                                if (note) {
                                    notes.push({ LegislationID: note.LegislationID, Note: note.Note, ListName: coll.Name });
                                }
                            });
                        }
                        if (this.state.selectedNotes === 'current') {
                            this.props.collections.filter(x => x.WatchListID === this.props.selectedCollection.WatchListID).forEach(coll => {
                                let note = coll.WatchListLegislation.find(leg => leg.LegislationID === bill.LegislationID && leg.Note);
                                if (note) {
                                    notes.push({ LegislationID: note.LegislationID, Note: note.Note, ListName: coll.Name });
                                }
                            });
                        }
                    }
                })
            }

            this.setState({ creating: true }, () => {
                const jsonData = JSON.stringify({
                    showCatchline: this.state.showCatchline,
                    showCurrentStatus: this.state.showCurrentStatus,
                    showTitle: this.state.showTitle,
                    showChiefPatron: this.state.showChiefPatron,
                    showAllPatrons: this.state.showAllPatrons,
                    showSummary: this.state.showSummary,
                    showNotes: this.state.showNotes,
                    userCreated: this.props.login.userProfile.email || '',
                    selectedNotes: this.state.selectedNotes,
                    selectedCollection: this.props.selectedCollection && this.props.selectedCollection.Name && this.props.selectedCollection.WatchListID ? this.props.selectedCollection.WatchListID : '',
                    reportTitle: this.props.reportTitle || this.props.selectedCollection?.Name ||  '',
                    showHistory: this.state.showHistory,
                    showHouseAmendments: this.state.showHouseAmendments,
                    showSenateAmendments: this.state.showSenateAmendments,
                    showConferenceAmendments: this.state.showConferenceAmendments,
                    showGovernorsRecommendations: this.state.showGovernorsRecommendations,
                    showStatus: this.state.showStatus,
                    showCommitteeEvent: this.state.showCommitteeEvent,
                    showLdNumber: this.state.showLdNumber,
                    showClerkNames: this.state.showClerkNames,
                    showDlsStaffNames: this.state.showDlsStaffNames,
                    personalMessage: this.state.personalMessage,
                    billList: billList,
                    sharedNotes: this.state.shareNotes,
                    includeVotes: this.state.showVotes,
                    NotesType: this.state.selectedNotes,
                    notes: notes
                });

                if (this.state.isDirty && this.state.reportTemplate && (this.state.reportTemplate.__isNew__ || this.state.reportTemplate.Name)) {
                    this.saveReportTemplate(window.btoa(jsonData));
                }

                this.props.actions.saveBillReportInformation(window.btoa(jsonData)).then(() => {
                    const billReportInformation = this.props.report.billReportInformation;
                    if (billReportInformation && billReportInformation.ReportNumber) {
                        this.props.history.push('/bill-search-report/' + billReportInformation.ReportNumber)
                    } else {
                        this.props.actions.makeToast([{ message: "Report Failed", type: "failure" }]);
                    }
                    this.setState({ creating: false })
                }).catch(err => {
                    if (err === 'Aborted') {
                        return;
                    }
                    console.log(err)
                    this.props.actions.makeToast([{ message: "Report Failed", type: "failure" }]);
                    this.setState({
                        creating: false
                    });
                })
            })
        }
    }

    toggleShowBills() {
        this.setState({
            showAllBills: !this.state.showAllBills
        })
    }

    checkParams() {
        for (const x in this.state) {
            if (typeof this.state[x] === "object") {
                for (const y in this.state[x]) {
                    if (this.state[x][y] === true)
                        return false;
                }
            } else if (this.state[x] === true && x !== "showAllBills") {
                return false;
            }
        }

        return true;
    }

    //Report bill range differs slightly from the bill search range functionality as it allows more advanced cross-chamber/cross-type searching.
    //Order is HB, HJ, HR, SB, SJ, SR.
    //If only one field is entered, it is ignored.
    //If list is empty, it displays an error.
    generateBillList() {
        const startType = this.state.startRange.substring(0, 2).toUpperCase(), endType = this.state.endRange.substring(0, 2).toUpperCase();
        const typeFilled = startType === '' || endType === '';
        const startRange = parseInt(this.state.startRange.substring(2), 10);
        const endRange = parseInt(this.state.endRange.substring(2), 10);

        //return empty array if startType is alphabetically greater than endType (e.g. startType === SB, endType === HB)
        if (startType.localeCompare(endType) === 1) {
            return [];
        }

        return this.props.billList ? this.props.billList.filter(bill => {
            const number = parseInt(bill.LegislationNumber.substring(2), 10), type = bill.LegislationNumber.substring(0, 2);
            return typeFilled ? true :
                //return true IF
                //startType (e.g. HB) === type (e.g. HB) && number (e.g. 123) >= startRange (e.g. 123)
                //OR type (e.g. SB) is alphabetically greater than startType (e.g. HB) && either endType (e.g. SR) !== type (e.g. SB) or number (e.g 123) <= endRange (e.g. 123)
                ((startType === type && number >= startRange) || (type.localeCompare(startType) === 1 && type.localeCompare(endType) < 1 && (endType !== type || number <= endRange)))
                //AND either endType (e.g. SR) !== type (e.g. HB) or number (e.g. 123) <= endRange (e.g. 123)
                && (endType !== type || number <= endRange)
        }).map(bill => ({
            LegislationNumber: bill.LegislationNumber,
            SessionID: bill.SessionID
        })) : []
    }

    selectAll() {
        this.setState({
            showCatchline: true,
            showCurrentStatus: true,
            showTitle: true,
            showChiefPatron: true,
            showAllPatrons: true,
            showSummary: true,
            showNotes: true,
            showHistory: {
                all: true,
                recent: false,
                mostRecentAmount: 0,
                showVotes: true,
                Committee: false,
                Subcommittee: false
            },
            showHouseAmendments: true,
            showSenateAmendments: true,
            showConferenceAmendments: true,
            showGovernorsRecommendations: true,
            showStatus: {
                showPassedHouse: true,
                showPassedSenate: true,
                showPassed: true,
                showApproved: true,
                showVetoed: true,
                showContinued: true,
                showFailed: true,
                showEmergency: true
            },
            showCommitteeEvent: {
                showFirstHouseCommittee: true,
                showFirstSenateCommittee: true,
                showLastHouseSubcommittee: true,
                showLastSenateSubcommittee: true
            },
            selectedNotes: "all",
            isDirty: true
        })
    }

    resetForm() {
        this.setState({
            showCatchline: false,
            showCurrentStatus: false,
            showTitle: false,
            showChiefPatron: false,
            showAllPatrons: false,
            showSummary: false,
            showNotes: false,
            showHistory: false,
            showHouseAmendments: false,
            showSenateAmendments: false,
            showConferenceAmendments: false,
            showGovernorsRecommendations: false,
            showStatus: {
                showPassedHouse: false,
                showPassedSenate: false,
                showPassed: false,
                showApproved: false,
                showVetoed: false,
                showContinued: false,
                showFailed: false,
                showEmergency: false
            },
            showCommitteeEvent: {
                showFirstHouseCommittee: false,
                showFirstSenateCommittee: false,
                showLastHouseSubcommittee: false,
                showLastSenateSubcommittee: false
            },
            selectedNotes: "all",
            isDirty: false,
            startRange: "",
            endRange: "",
            personalMessage: "",
            reportTemplate: null,
            shareNotes: false
        })
    }

    handleReportTemplateChange(value) {
        // If it is a new template, consider the form dirty so the save call happens.
        this.setState({
            reportTemplate: value,
            isDirty: !!value?.__isNew__,
            menuIsOpen: false
        }, () => {
            if (this.state.reportTemplate && !this.state.reportTemplate.__isNew__) {
                this.setState({
                    showCatchline: this.state.reportTemplate.Catchline,
                    showCurrentStatus: this.state.reportTemplate.CurrentStatus,
                    showTitle: this.state.reportTemplate.Title,
                    showChiefPatron: this.state.reportTemplate.ChiefPatron,
                    showAllPatrons: this.state.reportTemplate.AllPatrons,
                    showSummary: this.state.reportTemplate.Summary,
                    showNotes: this.state.reportTemplate.Notes,
                    showHistory: this.state.reportTemplate.all || this.state.reportTemplate.LastEvents || this.state.reportTemplate.LastEventsCount || this.state.reportTemplate.Votes || this.state.reportTemplate.LastCommitteeEvent || this.state.reportTemplate.LastSubcommitteeEvent
                        ? {
                            all: this.state.reportTemplate.LastEvents,
                            recent: this.state.reportTemplate.LastEventsCount != 0 ? true : false,
                            mostRecentAmount: this.state.reportTemplate.LastEventsCount,
                            showVotes: this.state.reportTemplate.IncludeVotes,
                            Committee: this.state.reportTemplate.LastCommitteeEvent,
                            Subcommittee: this.state.reportTemplate.LastSubcommitteeEvent
                        } : false,
                    showHouseAmendments: this.state.reportTemplate.HouseAmendments,
                    showSenateAmendments: this.state.reportTemplate.SenateAmendments,
                    showConferenceAmendments: this.state.reportTemplate.ConferenceAmendments,
                    showGovernorsRecommendations: this.state.reportTemplate.GovernorsRecommendations,
                    showStatus: {
                        showPassedHouse: this.state.reportTemplate.PassedHouse,
                        showPassedSenate: this.state.reportTemplate.PassedSenate,
                        showPassed: this.state.reportTemplate.Passed,
                        showApproved: this.state.reportTemplate.Approved,
                        showVetoed: this.state.reportTemplate.Vetoed,
                        showContinued: this.state.reportTemplate.Continued,
                        showFailed: this.state.reportTemplate.Failed,
                        showEmergency: this.state.reportTemplate.Emergency
                    },
                    showCommitteeEvent: {
                        showFirstHouseCommittee: this.state.reportTemplate.FirstHouseCommitteeReferred,
                        showFirstSenateCommittee: this.state.reportTemplate.FirstSenateCommitteeReferred,
                        showLastHouseSubcommittee: this.state.reportTemplate.LastHouseSubCommitteeAssigned,
                        showLastSenateSubcommittee: this.state.reportTemplate.LastSenateSubCommitteeAssigned
                    },
                    selectedNotes: this.state.reportTemplate.selectedNotes,
                    startRange: this.state.reportTemplate.BillRangeStart ? this.state.reportTemplate.BillRangeStart : "",
                    endRange: this.state.reportTemplate.BillRangeEnd ? this.state.reportTemplate.BillRangeEnd : "",
                    personalMessage: this.state.reportTemplate.PersonalMessage ?? '',
                    isDirty: false,
                    shareNotes: this.state.reportTemplate.SharedNotes,
                    selectedNotes: this.state.reportTemplate.NotesType
                })
            } else if (!this.state.reportTemplate) {
                this.resetForm();
            }
        })
    }

    getReportTemplates() {
        this.props.actions.getReportTemplates()
    }

    saveReportTemplate() {
        let template = { ...this.state.reportTemplate }

        template.name = template.__isNew__ ? template.label : this.state.reportTemplate.Name
        template.ReportParameterID = template.ReportParameterID ? template.ReportParameterID : null

        template.billList = "0"
        template.CatchLine = this.state.showCatchline
        template.CurrentStatus = this.state.showCurrentStatus
        template.Title = this.state.showTitle
        template.ChiefPatron = this.state.showChiefPatron
        template.AllPatrons = this.state.showAllPatrons
        template.Summary = this.state.showSummary
        template.Notes = this.state.showNotes
        template.LastEvents = this.state.showHistory.all
        template.LastEventsCount = this.state.showHistory.mostRecentAmount
        template.IncludeVotes = this.state.showHistory.showVotes
        template.LastCommitteeEvent = this.state.showHistory.Committee
        template.LastSubcommitteeEvent = this.state.showHistory.Subcommittee
        template.HouseAmendments = this.state.showHouseAmendments
        template.SenateAmendments = this.state.showSenateAmendments
        template.ConferenceAmendments = this.state.showConferenceAmendments
        template.GovernorsRecommendations = this.state.showGovernorsRecommendations
        template.PassedHouse = this.state.showStatus.showPassedHouse
        template.PassedSenate = this.state.showStatus.showPassedSenate
        template.Passed = this.state.showStatus.showPassed
        template.Approved = this.state.showStatus.showApproved
        template.Vetoed = this.state.showStatus.showVetoed
        template.Continued = this.state.showStatus.showContinued
        template.Failed = this.state.showStatus.showFailed
        template.Emergency = this.state.showStatus.showEmergency
        template.FirstHouseCommitteeReferred = this.state.showCommitteeEvent.showFirstHouseCommittee
        template.FirstSenateCommitteeReferred = this.state.showCommitteeEvent.showFirstSenateCommittee
        template.LastHouseSubcommitteeAssigned = this.state.showCommitteeEvent.showLastHouseSubcommittee
        template.LastSenateSubcommitteeAssigned = this.state.showCommitteeEvent.showLastSenateSubcommittee
        template.selectedNotes = this.state.reportTemplate.selectedNote
        template.BillRangeStart = this.state.startRange
        template.BillRangeEnd = this.state.endRange
        template.PersonalMessage = this.state.personalMessage
        template.SharedNotes = this.state.shareNotes
        template.NotesType = this.state.selectedNotes
        template.IsActive = true;

        this.props.actions.saveReportTemplate(template)
            .then(() => {
                this.setState({
                    isDirty: false
                })
            })
            .then(() => {
                this.props.actions.makeToast([{ message: "Report Template Saved", type: "success" }]);
                this.getReportTemplates();
            })
            .catch(err => {
                if (err === 'Aborted') {
                    return;
                }
                console.log(err)
                this.props.actions.makeToast([{ message: "Report Template Fetch Failed", type: "failure" }]);
            })
    }

    deleteReportTemplate() {
        let template = { ...this.state.reportTemplate };
        template.DeletionDate = new Date();
        template.IsActive = false;

        this.props.actions.deleteReportTemplate(template)
            .then(() => {
                this.props.actions.makeToast([{ message: "Report Template Deleted", type: "success" }]);
                this.getReportTemplates();
                this.resetForm();
                this.setState({
                    reportTemplate: {}
                })
            })
            .catch(err => {
                if (err === 'Aborted') {
                    return;
                }
                console.log(err)
                this.props.actions.makeToast([{ message: "Report Template Delete Failed", type: "failure" }]);
            })
    }

    componentDidMount() {
        if (this.props.login.isAuthenticated) {
            this.getReportTemplates();
        }
    }

    toggleMenuIsOpen(value) {
        if (value === undefined) {
            this.setState({ menuIsOpen: !this.state.menuIsOpen });
        } else {
            this.setState({ menuIsOpen: value });
        }
    }

    handleIsRelated(e, direction) {
        const relatedTarget = e.relatedTarget
        if (relatedTarget === null) {
            this.toggleMenuIsOpen(false);
        }
        const isParOfTheSelect = (el) => {
            let parent = el?.parentElement;
            if (parent) {
                if (parent.id === 'sr-report-params-control') {
                    return true;
                } else {
                    return isParOfTheSelect(parent);
                }
            } else {
                return false;
            }
        }
        const shouldClose = isParOfTheSelect(relatedTarget);
        if (shouldClose) {
            e.preventDefault();
            e.stopPropagation();
        }
        if (shouldClose && direction) {

        } else {
            this.toggleMenuIsOpen(shouldClose);
        }
    }

    manuallyFocusTheNextOne(direction) {
        // The id is different depending on where the Modal is ...
        const mainThing = document.getElementById('sr-report-params-control');
        mainThing?.getElementsByTagName('input')[0]?.focus();
        if (direction === 'down') {
            this.selectRef?.current?.select?.focusOption('down');
        } else if (direction === 'up') {
            this.selectRef?.current?.select?.focusOption('up');
        }
    }

    render() {
        const { showCatchline, showCurrentStatus, showTitle, showChiefPatron, showAllPatrons, showSummary, showNotes, selectedNotes, showHistory, showHouseAmendments, showSenateAmendments, showConferenceAmendments, showGovernorsRecommendations, showStatus, showCommitteeEvent, rangeError, showLdNumber, showClerkNames, showDlsStaffNames, DLS_STAFF, shareNotes } = this.state;

        let shortBillsList = '';
        let longBillsList = '';
        let limitReached = false;
        this.props.billList.forEach((bill, i) => {
            const current = shortBillsList;
            if (!limitReached) {
                shortBillsList += bill.LegislationNumber;
            }
            longBillsList += bill.LegislationNumber;
            if (i !== this.props.billList.length - 1) {
                if (!limitReached) {
                    shortBillsList += ', ';
                }
                longBillsList += ', ';
            }
            if (shortBillsList.length > 310 && !limitReached) {
                shortBillsList = current.substring(0, current.length - 2) + '...';
                limitReached = true;
            }
        })
        return (<div onClick={() => this.props.toggleReportMaker(this.props.autoReport)} className="overlay center-content">
            <div className="full" style={{ maxHeight: '100%' }}>
                <div onClick={e => e.stopPropagation()} className="report-maker dlas-forms user-forms advanced-search overlay-content animated-fade-in-up">
                    <div className='header' style={{ marginBottom: this.props.selectedCollection.Name && !window.location.href.includes('bill-details') ? '-10px' : '10px' }}>
                        <div className='title'>Create Report</div>
                        <button onClick={() => this.props.toggleReportMaker(this.props.autoReport)} className="close-cross" aria-label="close modal" />
                    </div>
                    {this.props.selectedCollection.Name && <div>
                        <h3>{this.props.selectedCollection.Name}</h3>
                    </div>}
                    <div className="inner-grid two-col-sidebar-tiny">
                        {this.props.billList && shortBillsList !== longBillsList
                            ?
                            <React.Fragment>
                                {this.state.showAllBills
                                    ?
                                    <React.Fragment>
                                        <p className="small-text">{longBillsList}</p>
                                        <button aria-label="Show all bill numbers" className="arrow-up" onClick={this.toggleShowBills} />
                                    </React.Fragment>
                                    :
                                    <React.Fragment>
                                        <p className="small-text">{shortBillsList}</p>
                                        <button aria-label="Show fewer bill numbers" className="arrow-down" onClick={this.toggleShowBills} />
                                    </React.Fragment>
                                }
                            </React.Fragment>
                            :
                            <p className="small-text">{longBillsList}</p>
                        }
                    </div>
                    {this.props.login.isAuthenticated &&
                        <div className='inner-grid eight-and-one'>
                            <div>
                                <label id='add-report-template-label'>Report Templates</label>
                                <Select
                                    aria-label="Report template selector - Select or Create"
                                    ref={this.selectRef}
                                    id="sr-report-params-control"
                                    styles={selectStyle}
                                    options={[{ isNew: true }].concat(this.props.report.reportTemplates)}
                                    getOptionLabel={opt => opt.label || opt.Name}
                                    getOptionValue={opt => opt.value || opt.ReportParameterID}
                                    value={this.state.reportTemplate}
                                    onChange={this.handleReportTemplateChange}
                                    placeholder={"Select or Create"}
                                    isClearable
                                    classNamePrefix='no-width-dropdown-input'
                                    components={{ 'Option': CustomOption, ClearIndicator: LisClearIndicator }}
                                    updateNew={this.handleReportTemplateChange}
                                    toggleMenuIsOpen={this.toggleMenuIsOpen}
                                    menuIsOpen={this.state.menuIsOpen}
                                    onMenuOpen={e => { this.toggleMenuIsOpen(!this.state.menuIsOpen) }}
                                    onBlur={e => { this.handleIsRelated(e) }}
                                    onKeyDown={e => {
                                        // So, arrow keys let you navigate through the options. But we want to be able to auto tab into the new input.
                                        // This works for the most part, until you tab into the select initially. Then you need to focus on that specifically.
                                        if (e.key === 'Tab' && this.selectRef?.current?.select?.state?.focusedOption?.isNew) {
                                            e.preventDefault();
                                            document.getElementById('add-new')?.focus();
                                        } else if (['ArrowDown', 'ArrowUp'].includes(e.key)) {
                                            const current = this.selectRef?.current?.select?.state?.focusedOption?.ReportParameterID;
                                            const menuOptions = this.selectRef?.current?.select?.state?.menuOptions?.render;
                                            if (menuOptions && menuOptions.length > 1 && current) {
                                                const index = menuOptions.findIndex(o => o.data?.ReportParameterID === current);
                                                if (index === 1 && e.key === 'ArrowUp') {
                                                    this.selectRef?.current?.select?.focusOption('up');
                                                    setTimeout(() => document.getElementById('add-new')?.focus())
                                                } else if (index === menuOptions.length - 1 && e.key === 'ArrowDown') {
                                                    this.selectRef?.current?.select?.focusOption('down');
                                                    setTimeout(() => document.getElementById('add-new')?.focus())
                                                }
                                            } else if (menuOptions && this.selectRef?.current?.select?.state?.focusedOption === undefined && e.key === 'ArrowDown') {
                                                setTimeout(() => document.getElementById('add-new')?.focus())
                                            }
                                        }
                                    }}
                                    manuallyFocusTheNextOne={this.manuallyFocusTheNextOne}
                                    handleIsRelated={this.handleIsRelated}
                                />
                            </div>
                            <button style={{ height: "32px", marginTop: "23px" }} type="button" className='button danger' onClick={() => this.deleteReportTemplate()} disabled={!this.state.reportTemplate || !this.state.reportTemplate.Name || this.state.reportTemplate.__isNew__} aria-label="Delete Report Template">Delete Template</button>
                        </div>
                    }
                    <div className={`inner-grid ${DLS_STAFF ? 'four' : 'three'}`}>
                        <div>
                            <div className="checkbox-container">
                                <div className="checkbox flex-row flex-vertical-center flex-start">
                                    <div className="toggle-switch" onClick={() => this.handleInputChange("showCatchline", !showCatchline)}>
                                        <input id="report-catchline" checked={showCatchline} type="checkbox" style={{ width: "auto" }} readOnly />
                                        <span className="slider"></span>
                                    </div>
                                    <label htmlFor="report-catchline" className="checkbox-label no-background">Catch line</label>
                                </div>
                                <div className="checkbox flex-row flex-vertical-center flex-start">
                                    <div className="toggle-switch" onClick={() => this.handleInputChange("showCurrentStatus", !showCurrentStatus)}>
                                        <input id="report-current-status" checked={showCurrentStatus} type="checkbox" style={{ width: "auto" }} readOnly />
                                        <span className="slider"></span>
                                    </div>
                                    <label htmlFor="report-current-status" className="checkbox-label no-background">Current Status</label>
                                </div>
                                <div className="checkbox flex-row flex-vertical-center flex-start">
                                    <div className="toggle-switch" onClick={() => this.handleInputChange("showSummary", !showSummary)}>
                                        <input id="report-summary" checked={showSummary} type="checkbox" style={{ width: "auto" }} readOnly />
                                        <span className="slider"></span>
                                    </div>
                                    <label htmlFor="report-summary" className="checkbox-label no-background">Summary</label>
                                </div>
                                <div className="checkbox flex-row flex-vertical-center flex-start">
                                    <div className="toggle-switch" onClick={() => this.handleInputChange("showTitle", !showTitle)}>
                                        <input id="report-title" checked={showTitle} type="checkbox" style={{ width: "auto" }} readOnly />
                                        <span className="slider"></span>
                                    </div>
                                    <label htmlFor="report-title" className="checkbox-label no-background">Title</label>
                                </div>
                                <div className="checkbox flex-row flex-vertical-center flex-start">
                                    <div className="toggle-switch" onClick={() => this.handleInputChange("showChiefPatron", !showChiefPatron)}>
                                        <input id="report-chief-patron" checked={showChiefPatron} type="checkbox" style={{ width: "auto" }} readOnly />
                                        <span className="slider"></span>
                                    </div>
                                    <label htmlFor="report-chief-patron" className="checkbox-label no-background">Chief Patron</label>
                                </div>
                                <div className="checkbox flex-row flex-vertical-center flex-start">
                                    <div className="toggle-switch" onClick={() => this.handleInputChange("showAllPatrons", !showAllPatrons)}>
                                        <input id="report-patrons" checked={showAllPatrons} type="checkbox" style={{ width: "auto" }} readOnly />
                                        <span className="slider"></span>
                                    </div>
                                    <label htmlFor="report-patrons" className="checkbox-label no-background">All Patrons</label>
                                </div>
                            </div>
                            <div className="checkbox-container">
                                <div style={{ padding: "10px", display: "inline-flex", width: "100%" }}>
                                    <label htmlFor="report-personal-message" className="label">Personal Message</label>
                                    <textarea id="report-personal-message" onChange={e => this.handleInputChange("personalMessage", e.target.value)} value={this.state.personalMessage} type="text" />
                                </div>
                            </div>
                            <div className='checkbox-container' style={{ padding: "10px" }}>
                                <div className="inner-grid two" style={{ gridGap: "10px" }}>
                                    <div className="inner-grid two" style={{ gridGap: "0" }}>
                                        <label style={{ padding: "0", marginRight: "15px" }} htmlFor="report-start-range" className="label report-range-start-label">Select From Bill #</label>
                                        <input id="report-start-range" onChange={e => this.handleInputChange("startRange", e.target.value)} type="text" value={this.state.startRange} className="report-range-input" />
                                    </div>
                                    <div className="inner-grid two" style={{ gridGap: "0" }}>
                                        <label style={{ padding: "0" }} htmlFor="report-end-range" className="label report-range-end-label">&nbsp;Through Bill #</label>
                                        <input id="report-end-range" onChange={e => this.handleInputChange("endRange", e.target.value)} type="text" value={this.state.endRange} className="report-range-input" />
                                    </div>
                                </div>
                                {rangeError && <span className="input-feedback">No bills within this range</span>}
                            </div>
                        </div>
                        <div>
                            <div className="checkbox-container">
                                <div className="checkbox flex-row flex-vertical-center flex-start">
                                    <div className="toggle-switch" onClick={() => this.handleInputChange("showHistory", showHistory === false ? { all: false, recent: false, mostRecentAmount: 5, showVotes: false, Committee: false, Subcommittee: false } : false)}>
                                        <input id="report-history" checked={showHistory} type="checkbox" style={{ width: "auto" }} readOnly />
                                        <span className="slider"></span>
                                    </div>
                                    <label htmlFor="report-history" className="checkbox-label no-background">Bill History</label>
                                </div>
                                <div style={{ marginLeft: '10px' }}>
                                    <div className="checkbox checkbox-group">
                                        <div className="checkbox flex-row flex-vertical-center flex-start">
                                            <div className="toggle-switch" disabled={!showHistory} onClick={() => this.handleInputChange("showHistory", { ...showHistory, all: !showHistory.all, recent: false })}>
                                                <input id="report-history-type-all" checked={showHistory.all} type="checkbox" style={{ width: "auto" }} readOnly />
                                                <span className="slider"></span>
                                            </div>
                                            <label htmlFor="report-history-type-all" className={`checkbox-label no-background${showHistory ? "" : " txt-greyed"}`}>All Events{showHistory.all && "*"}</label>
                                        </div>
                                    </div>
                                    <div className="checkbox checkbox-group">
                                        <div className="checkbox flex-row flex-vertical-center flex-start">
                                            <div className="toggle-switch" disabled={!showHistory} onClick={() => this.handleInputChange("showHistory", { ...showHistory, recent: !showHistory.recent, all: false })}>
                                                <input id="report-history-type-recent" checked={showHistory.recent} type="checkbox" style={{ width: "auto" }} readOnly />
                                                <span className="slider"></span>
                                            </div>
                                            <label className="screen-reader-only" htmlFor="report-history-type-recent-amount">Most recent amount</label>
                                            <label htmlFor="report-history-type-recent" className={`checkbox-label no-background${showHistory ? "" : " txt-greyed"}`}><input
                                                id="report-history-type-recent-amount"
                                                type="text"
                                                className="label-input"
                                                disabled={!showHistory.recent}
                                                value={showHistory.mostRecentAmount}
                                                onChange={(e) => {
                                                    const val = e.target.value;
                                                    if (val === '' || /[^0-9]/.test(val) === false) {
                                                        this.handleInputChange("showHistory", { ...showHistory, mostRecentAmount: val });
                                                    }
                                                }} />
                                                &nbsp;&nbsp;Last Events{showHistory.recent && showHistory.mostRecentAmount > 1 && "*"}</label>
                                        </div>
                                    </div>
                                    <div className="checkbox checkbox-group">
                                        <div className="checkbox flex-row flex-vertical-center flex-start">
                                            <div className="toggle-switch" disabled={!showHistory} onClick={() => this.handleInputChange("showHistory", { ...showHistory, Committee: !showHistory.Committee })}>
                                                <input id="report-history-type-committee" checked={showHistory.Committee} type="checkbox" style={{ width: "auto" }} readOnly />
                                                <span className="slider"></span>
                                            </div>
                                            <label htmlFor="report-history-type-committee" className={`checkbox-label no-background${showHistory ? "" : " txt-greyed"}`}>Last Committee Event</label>
                                        </div>
                                    </div>
                                    <div className="checkbox checkbox-group">
                                        <div className="checkbox flex-row flex-vertical-center flex-start">
                                            <div className="toggle-switch" disabled={!showHistory} onClick={() => this.handleInputChange("showHistory", { ...showHistory, Subcommittee: !showHistory.Subcommittee })}>
                                                <input id="report-history-type-sub" checked={showHistory.Subcommittee} type="checkbox" style={{ width: "auto" }} readOnly />
                                                <span className="slider"></span>
                                            </div>
                                            <label htmlFor="report-history-type-sub" className={`checkbox-label no-background${showHistory ? "" : " txt-greyed"}`}>Last Subcommittee Event</label>
                                        </div>
                                    </div>
                                </div>
                                {(showHistory.all || (showHistory.recent && showHistory.mostRecentAmount > 1)) &&
                                    <div className="checkbox checkbox-group">
                                        <div className="checkbox flex-row flex-vertical-center flex-start">
                                            <div className="toggle-switch" disabled={!showHistory} onClick={() => this.handleInputChange("showHistory", { ...showHistory, showVotes: !showHistory.showVotes })}>
                                                <input id="report-votes" checked={showHistory.showVotes} type="checkbox" style={{ width: "auto" }} readOnly />
                                                <span className="slider"></span>
                                            </div>
                                            <label htmlFor="report-votes" className={`checkbox-label no-background${showHistory ? "" : " txt-greyed"}`}>Include Votes for '{showHistory.all ? 'All Events' : showHistory.mostRecentAmount.toString() + ' Last Events'}'</label>
                                        </div>
                                    </div>
                                }
                            </div>
                            <div className="checkbox-container">
                                <div style={{ margin: '5px' }} className="small-text">Include this detail:</div>
                                <div className="checkbox flex-row flex-vertical-center flex-start">
                                    <div className="toggle-switch" onClick={() => this.handleInputChange('showCommitteeEvent', { ...showCommitteeEvent, showFirstHouseCommittee: !showCommitteeEvent.showFirstHouseCommittee })}>
                                        <input id="report-committee-house-referred" checked={showCommitteeEvent.showFirstHouseCommittee || ""} type="checkbox" style={{ width: "auto" }} readOnly />
                                        <span className="slider"></span>
                                    </div>
                                    <label htmlFor="report-committee-house-referred" className="checkbox-label no-background">First House Committee Referred</label>
                                </div>
                                <div className="checkbox flex-row flex-vertical-center flex-start">
                                    <div className="toggle-switch" onClick={() => this.handleInputChange('showCommitteeEvent', { ...showCommitteeEvent, showFirstSenateCommittee: !showCommitteeEvent.showFirstSenateCommittee })}>
                                        <input id="report-committee-senate-referred" checked={showCommitteeEvent.showFirstSenateCommittee || ""} type="checkbox" style={{ width: "auto" }} readOnly />
                                        <span className="slider"></span>
                                    </div>
                                    <label htmlFor="report-committee-senate-referred" className="checkbox-label no-background">First Senate Committee Referred</label>
                                </div>
                                <div className="checkbox flex-row flex-vertical-center flex-start">
                                    <div className="toggle-switch" onClick={() => this.handleInputChange('showCommitteeEvent', { ...showCommitteeEvent, showLastHouseSubcommittee: !showCommitteeEvent.showLastHouseSubcommittee })}>
                                        <input id="report-committee-house-assigned" checked={showCommitteeEvent.showLastHouseSubcommittee || ""} type="checkbox" style={{ width: "auto" }} readOnly />
                                        <span className="slider"></span>
                                    </div>
                                    <label htmlFor="report-committee-house-assigned" className="checkbox-label no-background">Last House Subcommittee Assigned</label>
                                </div>
                                <div className="checkbox flex-row flex-vertical-center flex-start">
                                    <div className="toggle-switch" onClick={() => this.handleInputChange('showCommitteeEvent', { ...showCommitteeEvent, showLastSenateSubcommittee: !showCommitteeEvent.showLastSenateSubcommittee })}>
                                        <input id="report-committee-senate-assigned" checked={showCommitteeEvent.showLastSenateSubcommittee || ""} type="checkbox" style={{ width: "auto" }} readOnly />
                                        <span className="slider"></span>
                                    </div>
                                    <label htmlFor="report-committee-senate-assigned" className="checkbox-label no-background">Last Senate Subcommittee Assigned</label>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div className="checkbox-container">
                                <div className="checkbox flex-row flex-vertical-center flex-start">
                                    <div className="toggle-switch" onClick={() => this.handleInputChange('showHouseAmendments', !showHouseAmendments)}>
                                        <input id="report-house-amendments" checked={showHouseAmendments} type="checkbox" style={{ width: "auto" }} readOnly />
                                        <span className="slider"></span>
                                    </div>
                                    <label htmlFor="report-house-amendments" className="checkbox-label no-background">House Amendments</label>
                                </div>
                                <div className="checkbox flex-row flex-vertical-center flex-start">
                                    <div className="toggle-switch" onClick={() => this.handleInputChange('showSenateAmendments', !showSenateAmendments)}>
                                        <input id="report-senate-amendments" checked={showSenateAmendments} type="checkbox" style={{ width: "auto" }} readOnly />
                                        <span className="slider"></span>
                                    </div>
                                    <label htmlFor="report-senate-amendments" className="checkbox-label no-background">Senate Amendments</label>
                                </div>
                                <div className="checkbox flex-row flex-vertical-center flex-start">
                                    <div className="toggle-switch" onClick={() => this.handleInputChange('showConferenceAmendments', !showConferenceAmendments)}>
                                        <input id="report-conference-amendments" checked={showConferenceAmendments} type="checkbox" style={{ width: "auto" }} readOnly />
                                        <span className="slider"></span>
                                    </div>
                                    <label htmlFor="report-conference-amendments" className="checkbox-label no-background">Conference Amendments</label>
                                </div>
                                <div className="checkbox flex-row flex-vertical-center flex-start">
                                    <div className="toggle-switch" onClick={() => this.handleInputChange('showGovernorsRecommendations', !showGovernorsRecommendations)}>
                                        <input id="report-governors-recommendations" checked={showGovernorsRecommendations} type="checkbox" style={{ width: "auto" }} readOnly />
                                        <span className="slider"></span>
                                    </div>
                                    <label htmlFor="report-governors-recommendations" className="checkbox-label no-background">Governor's Recommendations</label>
                                </div>
                            </div>
                            <div className="checkbox-container">
                                <div style={{ margin: '5px' }} className="small-text">Include whether the bill has ever been in this status:</div>
                                <div className="checkbox flex-row flex-vertical-center flex-start">
                                    <div className="toggle-switch" onClick={() => this.handleInputChange('showStatus', { ...showStatus, showPassedHouse: !showStatus.showPassedHouse })}>
                                        <input id="report-passed-house" checked={showStatus.showPassedHouse || ""} type="checkbox" style={{ width: "auto" }} readOnly />
                                        <span className="slider"></span>
                                    </div>
                                    <label htmlFor="report-passed-house" className="checkbox-label no-background">Passed House</label>
                                </div>
                                <div className="checkbox flex-row flex-vertical-center flex-start">
                                    <div className="toggle-switch" onClick={() => this.handleInputChange('showStatus', { ...showStatus, showPassedSenate: !showStatus.showPassedSenate })}>
                                        <input id="report-passed-senate" checked={showStatus.showPassedSenate || ""} type="checkbox" style={{ width: "auto" }} readOnly />
                                        <span className="slider"></span>
                                    </div>
                                    <label htmlFor="report-passed-senate" className="checkbox-label no-background">Passed Senate</label>
                                </div>
                                <div className="checkbox flex-row flex-vertical-center flex-start">
                                    <div className="toggle-switch" onClick={() => this.handleInputChange('showStatus', { ...showStatus, showPassed: !showStatus.showPassed })}>
                                        <input id="report-passed" checked={showStatus.showPassed || ""} type="checkbox" style={{ width: "auto" }} readOnly />
                                        <span className="slider"></span>
                                    </div>
                                    <label htmlFor="report-passed" className="checkbox-label no-background">Passed</label>
                                </div>
                                <div className="checkbox flex-row flex-vertical-center flex-start">
                                    <div className="toggle-switch" onClick={() => this.handleInputChange('showStatus', { ...showStatus, showApproved: !showStatus.showApproved })}>
                                        <input id="report-approved" checked={showStatus.showApproved || ""} type="checkbox" style={{ width: "auto" }} readOnly />
                                        <span className="slider"></span>
                                    </div>
                                    <label htmlFor="report-approved" className="checkbox-label no-background">Approved</label>
                                </div>
                                <div className="checkbox flex-row flex-vertical-center flex-start">
                                    <div className="toggle-switch" onClick={() => this.handleInputChange('showStatus', { ...showStatus, showVetoed: !showStatus.showVetoed })}>
                                        <input id="report-vetoed" checked={showStatus.showVetoed || ""} type="checkbox" style={{ width: "auto" }} readOnly />
                                        <span className="slider"></span>
                                    </div>
                                    <label htmlFor="report-vetoed" className="checkbox-label no-background">Vetoed</label>
                                </div>
                                <div className="checkbox flex-row flex-vertical-center flex-start">
                                    <div className="toggle-switch" onClick={() => this.handleInputChange('showStatus', { ...showStatus, showContinued: !showStatus.showContinued })}>
                                        <input id="report-continued" checked={showStatus.showContinued || ""} type="checkbox" style={{ width: "auto" }} readOnly />
                                        <span className="slider"></span>
                                    </div>
                                    <label htmlFor="report-continued" className="checkbox-label no-background">Continued</label>
                                </div>
                                <div className="checkbox flex-row flex-vertical-center flex-start">
                                    <div className="toggle-switch" onClick={() => this.handleInputChange('showStatus', { ...showStatus, showFailed: !showStatus.showFailed })}>
                                        <input id="report-failed" checked={showStatus.showFailed || ""} type="checkbox" style={{ width: "auto" }} readOnly />
                                        <span className="slider"></span>
                                    </div>
                                    <label htmlFor="report-failed" className="checkbox-label no-background">Failed</label>
                                </div>
                                <div className="checkbox flex-row flex-vertical-center flex-start">
                                    <div className="toggle-switch" onClick={() => this.handleInputChange('showStatus', { ...showStatus, showEmergency: !showStatus.showEmergency })}>
                                        <input id="report-emergency" checked={showStatus.showEmergency || ""} type="checkbox" style={{ width: "auto" }} readOnly />
                                        <span className="slider"></span>
                                    </div>
                                    <label htmlFor="report-emergency" className="checkbox-label no-background">Emergency</label>
                                </div>
                            </div>
                            {this.props.login.userClaims.resources.find(resource => resource === BILL_COLLECTION_AUTHOR) &&
                                <div className="checkbox-container">
                                    <div className="checkbox flex-row flex-vertical-center flex-start">
                                        <div className="toggle-switch" onClick={() => this.handleInputChange('showNotes', !showNotes)}>
                                            <input id="report-notes" checked={showNotes} type="checkbox" style={{ width: "auto" }} readOnly />
                                            <span className="slider"></span>
                                        </div>
                                        <label htmlFor="report-notes" className="checkbox-label no-background">Notes</label>
                                    </div>
                                    {this.props.selectedCollection && this.props.selectedCollection.Name && this.props.selectedCollection.WatchListID &&
                                        <div className="checkbox">
                                            <label htmlFor="report-notes-from-collection" className={`label radio-label ${showNotes ? "" : "txt-greyed"}`}>
                                                <input id="report-notes-from-collection" disabled={!showNotes} checked={selectedNotes === 'current'} onChange={() => this.handleInputChange("selectedNotes", 'current')} type="radio" readOnly />
                                                Notes from {this.props.selectedCollection.Name}
                                            </label>
                                            <label htmlFor="report-notes-from-all" className={`label radio-label ${showNotes ? "" : "txt-greyed"}`}>
                                                <input id="report-notes-from-all" disabled={!showNotes} checked={selectedNotes === 'all'} onChange={() => this.handleInputChange("selectedNotes", 'all')} type="radio" readOnly />
                                                All Notes
                                            </label>
                                        </div>
                                    }
                                    {/* this.state.showNotes &&
                                        <div className="checkbox flex-row flex-vertical-center flex-start">
                                            <div className="toggle-switch" onClick={() => this.handleInputChange('shareNotes', !shareNotes)}>
                                                <input id="report-share-notes" checked={shareNotes} type="checkbox" style={{ width: "auto" }} />
                                                <span className="slider"></span>
                                            </div>
                                            <label htmlFor="report-share-notes" className="checkbox-label no-background">Share Notes**</label>
                                        </div>
                                     */}
                                </div>
                            }
                        </div>
                        {DLS_STAFF &&
                            <div>
                                <div className="checkbox-container">
                                    <div className="checkbox flex-row flex-vertical-center flex-start">
                                        <div className="toggle-switch" onClick={() => this.handleInputChange('showLdNumber', !showLdNumber)}>
                                            <input id="report-ld-number" checked={showLdNumber} type="checkbox" style={{ width: "inherit" }} readOnly />
                                            <span className="slider"></span>
                                        </div>
                                        <label htmlFor="report-ld-number" className="checkbox-label no-background">LD Number of current version</label>
                                    </div>
                                    <div className="checkbox flex-row flex-vertical-center flex-start">
                                        <div className="toggle-switch" onClick={() => this.handleInputChange('showClerkNames', !showClerkNames)}>
                                            <input id="report-clerk-names" checked={showClerkNames} type="checkbox" style={{ width: "inherit" }} readOnly />
                                            <span className="slider"></span>
                                        </div>
                                        <label htmlFor="report-clerk-names" className="checkbox-label no-background">Show clerk name(s) of current committee</label>
                                    </div>
                                    <div className="checkbox flex-row flex-vertical-center flex-start">
                                        <div className="toggle-switch" onClick={() => this.handleInputChange('showDlsStaffNames', !showDlsStaffNames)}>
                                            <input id="report-staff-names" checked={showDlsStaffNames} type="checkbox" style={{ width: "inherit" }} readOnly />
                                            <span className="slider"></span>
                                        </div>
                                        <label htmlFor="report-staff-names" className="checkbox-label no-background">Show DLS staff name(s) of current committee</label>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                    {(showHistory.all || (showHistory.recent && showHistory.mostRecentAmount > 1)) && <small>* If you include '{showHistory.all ? 'All Events' : showHistory.mostRecentAmount.toString() + ' Last Events'}' for each bill, and decide to generate a CSV on the resulting report, 2 CSVs will be generated: one CSV containing '{showHistory.all ? 'All Events' : showHistory.mostRecentAmount.toString() + ' Last Events'}' on that bill, and another CSV containing all other selected options (e.g. Catch line, Summary, etc.).</small>}
                    <br />
                    {shareNotes && <small>**Sharing notes means that your notes will be visible to anyone who possesses the report URL. Exercise caution when sharing your report URL.</small>}
                    <div className="inline-list buttons">
                        <button className='button primary' onClick={() => this.selectAll()}>Select All</button>
                        <button className='button primary reset-form' onClick={() => this.resetForm()}>Reset Form</button>
                        <button style={{ marginRight: "0", marginLeft: "0px", float: "right" }} type="button" className="button right" disabled={this.state.creating || this.checkParams()} onClick={() => this.goToReport()}>{this.state.creating ? 'Creating' : this.state.reportTemplate && this.state.reportTemplate.__isNew__ ? 'Create Template & Report' : this.state.reportTemplate && this.state.reportTemplate.Name && this.state.isDirty ? "Save Template & Create Report" : 'Create Report'}</button>
                        <button style={{ float: "right" }} type="button" className="button secondary right" onClick={() => this.props.toggleReportMaker(this.props.autoReport)}>Cancel</button>
                    </div>
                </div>
            </div>
        </div>);
    }
}

export default connect(
    (state) => {
        const { login, nav, report } = state;
        return {
            login,
            nav,
            report
        }
    },
    (dispatch) => {
        return {
            actions: bindActionCreators(Object.assign({}, authActionCreators, navActionCreators, reportActionCreators), dispatch)
        }
    }
)(ReportMaker);

// Either we make the shared one generic, or just have one for reports
const CustomOption = ({ children, ...props }) => {

    const [newReportTemplate, setnewReportTemplate] = useState("");

    const selectOption = () => { };
    const stop = (e, focus) => {
        e.stopPropagation();
        focus && document.getElementById('add-new')?.focus();
        props.selectProps.toggleMenuIsOpen(true);
    }

    const newProps = props.data.isNew ?
        {
            ...props,
            selectOption,
            innerProps: {
                ...props.innerProps,
                onClick: (e) => stop(e)
            }
        } :
        props;

    const handleKeyPress = e => {
        e.stopPropagation();
        if (['Enter'].includes(e.key)) {
            e.preventDefault();
            addReportTemplate();
        } else if (e.key === 'Tab') {
            if (e.shiftKey) {
                e.preventDefault();
                props.selectProps.manuallyFocusTheNextOne();
            } else if (newReportTemplate.length === 0) {
                e.preventDefault();
                props.selectProps.manuallyFocusTheNextOne('down');
            } else {
                e.preventDefault();
                e.stopPropagation();
                document.getElementById('add-new-button')?.focus();
            }
        } else if (e.key === 'ArrowDown') {
            e.preventDefault();
            props.selectProps.manuallyFocusTheNextOne('down');
        }
        else if (e.key === 'ArrowUp') {
            e.preventDefault();
            props.selectProps.manuallyFocusTheNextOne('up');
        }
    }

    const addReportTemplate = (e) => {
        e?.preventDefault();
        if (newReportTemplate.length === 0) return;
        props.selectProps.updateNew({ label: newReportTemplate, value: newReportTemplate, __isNew__: true });
        setnewReportTemplate('');
        document.getElementById('add-report-template-label')?.focus();
        setTimeout(() => props.selectProps.toggleMenuIsOpen(false));
    }

    const handleBlur = (e, acceptableId) => {
        if (![acceptableId, 'add-new-holder'].includes(e.relatedTarget?.id)) {
            props.selectProps.handleIsRelated(e, 'down');
        }
    }

    const handleButtonNavigation = e => {
        if (e.key === 'Tab') {
            if (e.shiftKey) {
                e.preventDefault();
                document.getElementById('add-new')?.focus();
            } else {
                e.preventDefault();
                props.selectProps.manuallyFocusTheNextOne();
            }
        } else if (e.key === 'ArrowDown') {
            e.preventDefault();
            props.selectProps.manuallyFocusTheNextOne('down');
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            props.selectProps.manuallyFocusTheNextOne('up');
        }
    }

    return props.data.isNew ?
        <components.Option {...newProps}>
            <div id='add-new-holder' tabIndex={-1} style={{ display: 'grid', gridTemplateColumns: '1fr .1fr', gap: '5px' }}>
                <input aria-label="New report template name" id='add-new' placeholder='Add new template' value={newReportTemplate} onChange={e => { e.preventDefault(); setnewReportTemplate(e.target.value) }}
                    onMouseDown={e => stop(e)} onClick={(e => { stop(e, true) })} onKeyDown={handleKeyPress} onKeyPress={handleKeyPress} onBlur={e => handleBlur(e, 'add-new-button')} />
                <div>
                    <button id='add-new-button' style={{ padding: '11px', marginTop: '2px', marginLeft: '5px', borderRadius: '10px', backgroundPosition: 'center' }} disabled={newReportTemplate.length === 0} aria-label='add new report template' className='button add-wide' onClick={addReportTemplate}
                        onKeyDown={e => { e.stopPropagation(); handleButtonNavigation(e) }} onKeyPress={e => { e.stopPropagation(); handleButtonNavigation(e) }} onKeyUp={e => e.stopPropagation()} onBlur={e => handleBlur(e, 'add-new')} />
                </div>
            </div>
        </components.Option>
        :
        <components.Option {...props}>
            {children}
        </components.Option>
};
